import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
const _excluded = ["className", "children", "rounded", "type"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { useTheme } from '@emotion/react';
import clsx from 'clsx';
import { text } from '../assets/styles/utility';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StylesBadgeVariables = theme => ({
  height: theme.height['3xsmall']
});
export const StylesBadgeBase = theme => _objectSpread(_objectSpread(_objectSpread({
  background: theme.color.panel.dark,
  border: theme.border.base,
  borderRadius: theme.borderRadius.base,
  color: theme.fontColor.base,
  cursor: 'default',
  display: 'inline-flex',
  alignItems: 'center',
  padding: `0 ${theme.space.small}px`
}, theme.text.xsmall), text.expanded(theme)), {}, {
  fontWeight: theme.fontWeight.bold,
  height: StylesBadgeVariables(theme).height,
  textAlign: 'center',
  userSelect: 'none'
});
export const StylesBadgeSecondary = theme => ({
  borderColor: theme.fontColor.base,
  background: theme.fontColor.base,
  color: theme.contrast.base
});
export const StylesBadgePrimary = theme => ({
  borderColor: theme.color.primary.base,
  background: theme.color.primary.base,
  color: theme.contrast.base
});
export const StylesBadgeDanger = theme => ({
  borderColor: theme.color.danger.base,
  background: theme.color.danger.base,
  color: theme.contrast.base
});
export const StylesBadgeWarning = theme => ({
  borderColor: theme.color.warning.base,
  background: theme.color.warning.base,
  color: theme.contrast.base
});
export const StylesBadgeInfo = theme => ({
  borderColor: theme.color.info.base,
  background: theme.color.info.base,
  color: theme.contrast.base
});
export const StylesBadgeRounded = theme => ({
  borderRadius: theme.borderRadius.rounded
});

const Badge = _ref => {
  let {
    className,
    children,
    rounded,
    type
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  return ___EmotionJSX("div", _extends({
    css: [StylesBadgeBase(theme), type === 'primary' && StylesBadgePrimary(theme), type === 'danger' && StylesBadgeDanger(theme), type === 'secondary' && StylesBadgeSecondary(theme), type === 'warning' && StylesBadgeWarning(theme), type === 'info' && StylesBadgeInfo(theme), rounded && StylesBadgeRounded(theme), process.env.NODE_ENV === "production" ? "" : ";label:Badge;"],
    className: clsx('CK__Badge', className)
  }, rest), children);
};

export default Badge;